// extracted by css-extract-rspack-plugin
var _1 = "m8GvBKVF20sjydPF";
var _2 = "m8GvBKVF20sjydPF";
var _3 = "nkNDC9mqmvEA8BQr";
var _4 = "nkNDC9mqmvEA8BQr";
var _5 = "Xrqo6JtO37kSbaKY";
var _6 = "wcZ6UgD1guwiz7HJ";
var _7 = "BZtwlV8k_t8YqVcb";
var _8 = "LHj49SOURqkklhzg";
var _9 = "uk2vMl3H2_gL4t7J";
var _a = "yyqU20HD6UpHdtQv";
var _b = "SYhtw_DJPYEWn5S_";
var _c = "t757zV7Il2IOVQ1i";
var _d = "Xrqo6JtO37kSbaKY";
var _e = "wcZ6UgD1guwiz7HJ";
var _f = "BZtwlV8k_t8YqVcb";
var _10 = "LHj49SOURqkklhzg";
var _11 = "uk2vMl3H2_gL4t7J";
var _12 = "yyqU20HD6UpHdtQv";
var _13 = "SYhtw_DJPYEWn5S_";
var _14 = "t757zV7Il2IOVQ1i";
export { _1 as "donut-chart-legend", _2 as "donutChartLegend", _3 as "legend--bottom", _4 as "legendBottom", _5 as "ts-attempts", _6 as "ts-attempts__chart", _7 as "ts-attempts__chart-wrap", _8 as "ts-attempts__title", _9 as "ts-card--medium", _a as "ts-card--squared", _b as "ts-rank", _c as "ts-rank__label", _d as "tsAttempts", _e as "tsAttemptsChart", _f as "tsAttemptsChartWrap", _10 as "tsAttemptsTitle", _11 as "tsCardMedium", _12 as "tsCardSquared", _13 as "tsRank", _14 as "tsRankLabel" }
